import { useContactStore, selectFilteredContacts } from '../../store/contactStore'
import ContactCard from './ContactCard'

export default function ContactList() {
  const contacts = useContactStore(selectFilteredContacts)

  if (contacts.length === 0) {
    return (
      <div className="p-6 text-center text-sm text-gray-500">
        No contacts match the current filters yet.
      </div>
    )
  }

  return (
    <div className="overflow-y-auto overscroll-contain h-full p-2 space-y-1.5">
      {contacts.map((c) => (
        <ContactCard key={c.id} contact={c} />
      ))}
    </div>
  )
}
